module.exports = __webpack_public_path__ + "img/banner-life-on-land.b7774f08.png";